import { FC } from 'react';
import Chip, { ChipColor } from './';

export type ChipStatus =
  | 'inactive'
  | 'pending'
  | 'active'
  | 'creating'
  | 'updating'
  | 'deleting'
  | 'error'
  | 'failed'
  | 'unknown'
  | 'enabled'
  | 'disabled';

interface Props {
  value: ChipStatus;
  size?: 'x-small' | 'small' | 'medium';
}

const ColorMap: Map<ChipStatus, ChipColor> = new Map();
ColorMap.set('inactive', 'grey');
ColorMap.set('pending', 'warning');
ColorMap.set('active', 'success');
ColorMap.set('creating', 'info');
ColorMap.set('updating', 'warning');
ColorMap.set('deleting', 'warning');
ColorMap.set('error', 'error');
ColorMap.set('failed', 'error');
ColorMap.set('unknown', 'warning');
ColorMap.set('enabled', 'success');
ColorMap.set('disabled', 'grey');

const StatusChip: FC<Props> = ({ value, size = 'medium' }) => {
  return (
    <Chip
      label={String(value || 'unknown').toUpperCase()}
      color={ColorMap.get(value) || 'grey'}
      size={size}
    />
  );
};

export default StatusChip;
